 <template>
  <div class="content_box">
    <div class="header-text">
      <AppNewHeader
        :userName="userName"
        style="width: 100%"
        :placeholderText="'搜索知识资源'"
      />
      <div class="headerImage">知识库建设解决方案</div>

      <div class="content">
        <div class="contentText">
          <div class="contentLeft">
            <div class="demo-collapse">
              <el-collapse v-model="activeNames" @change="handleChange">
                <el-collapse-item
                  v-for="(item, itemIndex) in collapseItems"
                  :key="item.name"
                  :title="item.title"
                  :name="item.name"
                  class="custom-collapse-item"
                >
                  <template #title>
                    <div class="title-wrapper">
                      <el-icon class="title-icon"><Document /></el-icon>
                      <span>{{ item.title || "" }}</span>
                    </div>
                  </template>
                  <div
                    v-for="(content, contentIndex) in item.contents"
                    :key="contentIndex"
                    class="collapse-content"
                    :class="{ 
                      active: activeIndex === contentIndex && activeParentIndex === itemIndex 
                    }"
                    @click="selectContent(content, contentIndex, itemIndex)"
                  >
                    <el-icon
                      v-show="activeIndex === contentIndex && activeParentIndex === itemIndex"
                      class="content-icon"
                    >
                      <ArrowRight />
                    </el-icon>
                    <span>{{ content.text }}</span>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
          <div class="contentRight">
            <div v-if="currentArticle" class="article-content">
              <h2>{{ currentArticle.title }}</h2>
              <div class="right_text">
                <p v-html="currentArticle.content"></p>
              </div>
              <div class="currentImg">
                <img :src="currentArticle.url" alt="" />
              </div>
            </div>
            <div v-else class="empty-tip">请从左侧选择内容</div>
          </div>
        </div>
      </div>
    </div>

    <el-footer>
      <div>
        <AppFooter />
      </div>
    </el-footer>
  </div>
</template>

<script setup>
import { ref, onMounted, watch,onUnmounted } from "vue";
import { ArrowRight, Document } from "@element-plus/icons-vue";
import AppFooter from "@/views/components/AppFooter.vue";
import AppNewHeader from "@/views/components/AppNewHeader.vue";
import { collapseItems } from "@/views/home/data";
import { useRoute } from "vue-router";
import { Cookie } from "@/utils/Cookie";
import { getBuyLog } from "@/api/index.js";
import { usePageStayTime } from "@/utils/usePageStayTime";

const route = useRoute();
const { stayTime, totalStayTimes } = usePageStayTime();

// 状态管理
const activeNames = ref([]);
const activeIndex = ref(0); // 当前选中的内容索引
const activeParentIndex = ref(0); // 当前选中的父级索引
const currentArticle = ref(null);
const textValue = ref("");
const weburl = ref(window.location.href);
const userName = ref("");

// 初始化选中状态
const initActiveState = () => {
  // 优先使用路由参数
  const routeIndex = route.query.index;
  if (routeIndex) {
    for (let i = 0; i < collapseItems.length; i++) {
      const item = collapseItems[i];
      for (let j = 0; j < item.contents.length; j++) {
        if (item.contents[j].id == routeIndex) {
          activeNames.value = [item.name];
          activeIndex.value = j;
          activeParentIndex.value = i;
          updateCurrentArticle(item.contents[j]);
          return;
        }
      }
    }
  }
  
  // 如果没有路由参数，默认选中第一个
  if (collapseItems.length > 0 && collapseItems[0].contents.length > 0) {
    activeNames.value = [collapseItems[0].name];
    activeIndex.value = 0;
    activeParentIndex.value = 0;
    updateCurrentArticle(collapseItems[0].contents[0]);
  }
};
const updateCurrentArticle = (content) => {
  currentArticle.value = {
    title: content.text,
    content: content.content || content.text,
    url: content.url
  };
  textValue.value = content.text;
};
// 选择内容项
const selectContent = (content, contentIndex, parentIndex) => {
  activeIndex.value = contentIndex;
  activeParentIndex.value = parentIndex;
  updateCurrentArticle(content);
};

// 检查token状态
const checkTokenStatus = async () => {
  const token = JSON.parse(Cookie.get("token")) || "";
  if (token && !isTokenExpired(token)) {
    const userString = JSON.parse(Cookie.get("userInfo")) || null;
    const user = userString || null;
        userName.value = user?.realName;;
  }
};

// 检查token是否过期
const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp) {
      return Date.now() >= payload.exp * 1000;
    }
    return false;
  } catch (e) {
    return true;
  }
};

// 记录日志
const handleLog = async () => {
  try {
    await getBuyLog({
      type: "9",
      url: weburl.value,
      text: textValue.value,
      second: stayTime._value,
    });
  } catch (error) {
    console.error("记录日志失败:", error);
  }
};

// 页面加载处理
window.addEventListener("load", async () => {
  const stored = localStorage.getItem("lastSelectTime");
  const hiddenTime = Math.floor((Date.now() - (stored || Date.now())) / 1000);
  
  try {
    const res = await getBuyLog({
      type: "9",
      url: weburl.value,
      second: hiddenTime,
    });
    if (res.status == 200) {
      localStorage.setItem("lastSelectTime", Date.now().toString());
    }
  } catch (error) {
    console.error("页面加载日志记录失败:", error);
  }
});

// 组件挂载
onMounted(() => {
  checkTokenStatus();
  initActiveState();
});

// 组件卸载
onUnmounted(() => {
  handleLog();
});

// 监听路由变化
watch(
  () => route.query.index,
  (newIndex) => {
    if (newIndex) {
      initActiveState();
    }
  }
);

// 折叠面板变化处理
const handleChange = (val) => {
  console.log("当前展开的面板:", val);
};
</script>

<style scoped>
.content_box {
  background: #edf3fb;
}
.el-footer {
  --el-footer-padding: 0;
  --el-footer-height: 0;
  box-sizing: border-box;
  flex-shrink: 0;
  height: var(--el-footer-height);
  padding: var(--el-footer-padding);
  margin-top: 30px;
}

.headerImage {
  width: 100%;
  height: 200px;
  background-image: url(@/assets/newimages/jjfan.png);
  background-size: cover;
  margin-bottom: 40px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 36px;
  color: #ffffff;
  text-align: center;
  font-style: normal;
  line-height: 200px;
}

.content {
  width: 100%;
  min-height: 700px;
  display: flex;
  justify-content: center;
}

.contentText {
  min-width: 1400px;
  min-height: 700px;
  display: flex;
  justify-content: space-between;
}

.contentLeft {
  width: 294px;
  box-sizing: border-box;
  /* background-color: #ffffff; */
  /* border: 1px solid #d3d3d3; */
  overflow-y: auto;
  height: 425px;
}

.contentRight {
  width: 1080px;
  padding: 20px 30px;
  box-sizing: border-box;
  background-color: #ffffff;
  border: 1px solid #d3d3d3;
}

.demo-collapse {
  width: 100%;
}

/* 自定义折叠面板项样式 */
:deep(.custom-collapse-item) {
  background-color: #1f55de; /* 绿色背景 */
  /* margin-bottom: 8px; */
  border-radius: 4px;
  border: none;
}

/* 去掉右侧箭头 */
:deep(
    .custom-collapse-item .el-collapse-item__header .el-collapse-item__arrow
  ) {
  display: none;
}
:deep(.custom-collapse-item .el-collapse-item__header) {
  /* display: none; */
  background-color: #1f55de;
  margin-bottom: 2px;
  color: #ffffff;
  font-size: 16px;
}
/* 标题样式 */
.title-wrapper {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  width: 100%;
}

.title-icon {
  margin-right: 8px;
  color: #fff; /* 绿色图标 */
  font-size: 16px;
}

/* 内容项样式 */
.collapse-content {
  padding: 12px 16px 12px 36px; /* 左侧留出图标空间 */
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 3px;
  font-size: 14px;
  color: #666666;
  background-color: #f8fafd;
  height: 35px;
}

.content-icon {
  position: absolute;
  left: 16px;
  color: #1f55de; /* 绿色图标 */
  font-size: 14px;
}

.collapse-content:hover {
  background-color: #f5f7fa;
}

.collapse-content.active {
  /* background-color: #ecf5ff; */
  color: rgb(61, 104, 137);
  /* font-weight: 500; */
}

/* .article-content {
  padding: 20px;
} */

.article-content h2 {
  line-height: 30px;
  color: #3d6889;
  font-size: 18px;
  text-align: center;
  border-bottom: 1px dashed #d3d3d3;
  margin-bottom: 20px;
  padding-bottom: 10px;
}

.empty-tip {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #909399;
  font-size: 16px;
}

::v-deep .el-collapse-item__wrap {
  background-color: #edf3fb;
  /* border: 1px solid #ccc; */
}
.right_text p {
  color: rgb(102, 102, 102);
  font-size: 16px;
  font-weight: 400;
  line-height: 32px;
  text-indent: 2em;
  text-align: justify;
}

.article-content h3 {
  color: #548dd4;
  font-size: 18px;
  font-weight: 400;
  margin: 32px 0 32px 0;
}
.currentImg {
  display: flex;
  justify-content: center;
}
.currentImg img {
  width: 1000px;
}
</style>
